<template>
  <div id="Dashboard">
  	<b-container fluid>
  		<b-row>
			<transition name="fade">
  			<b-col id="main_nav" sm="12" class="bg-blue" v-if="main_nav_visibility">

  				<div class="only-desktop">
  					<img class="scale" src="/static/logo.png" style="display:block" />
  				</div>

				<div id="mobile_user_info" class="only-mobile">
					<div class="close" @click="main_nav_visibility=false">
						<font-awesome-icon :icon="['far', 'times-circle']" style="color:white;"/>
					</div>
					
					<div class="user_pic">
						<img class="scale" src="/static/re.png" />
					</div>
					<br>

					<div style="display:flex;align-items:center;justify-content: center;flex-direction:column">
						<h3 style="color:white;">{{user_info.full_name}}</h3>
						<b-link href="#" style="margin:0 5px">Your Account</b-link>
						<b-link @click="logout" style="margin:0 5px">Logout</b-link>
					</div>
  							
				</div>  				

  				<b-container fluid class="nav-main-link collapsible"  >
  					<b-row align-v="center" v-b-toggle.collapse1>
  						<b-col class="nav-icon" cols="1">
  							<font-awesome-icon icon="question-circle"   style="color:white" />
  						</b-col>
  						<b-col class="" cols="9">
  							<h6  class="collapsible-heading">Queries</h6>
  						</b-col>
  						<b-col class="toggler" cols="2">
  							
  						 	    <font-awesome-icon icon="angle-up" style="color:white"/>
  						 	
  						</b-col>
  					</b-row>
  					<b-row>
  						<b-col>
  							<b-collapse id="collapse1" class="mt-2">
  								<ul class="collapsible-ul">
  									
  									<li>
  										<div @click="goto('/dashboard/assigned')">
  											<b-link to="/dashboard/assigned">Assigned</b-link>
  										</div>
									  </li>
                    <li>
                      <div @click="goto('/dashboard/doubts-all')">
                        <b-link to="/dashboard/doubts-all">History</b-link>
                      </div>
                    </li>
  									<!-- <li><b-link to="/Dashboard/history">History</b-link></li> -->
  								</ul>

  							</b-collapse>		
  						</b-col>
  					</b-row>					
  				</b-container> <!-- queries -->

          <b-container fluid="true" class="nav-main-link collapsible"  >
            <b-row align-v="center">
              <b-col class="nav-icon" cols=1>
                <font-awesome-icon icon="at"   style="color:white" />
              </b-col>
              <b-col cols=9>
                <b-link disabled>Mailbox</b-link>
              </b-col>
              <b-col>
              
              </b-col>
              
            </b-row>
          </b-container> <!-- mailbox -->

          <b-container fluid="true" class="nav-main-link collapsible"  >
            <b-row align-v="center">
              <b-col class="nav-icon" cols=1>
                <font-awesome-icon icon="rupee-sign"   style="color:white" />
              </b-col>
              <b-col cols=9>
                <div @click="goto('/dashboard/transactions')">
                  <b-link to='/dashboard/transactions' class="normal-link">Reports/Earnings</b-link>
                </div>
              </b-col>
              <b-col>
              
              </b-col>
              
            </b-row>
          </b-container> <!-- earnings -->

  			</b-col>
			</transition>
  			<b-col id="main_wrapper">
  				<div id="top_bar" class="shadow-1" style="display:flex;">
  					<!-- <b-row align-v="center" align-h="between">
  						<b-col lg="7">
  						</b-col>
  						<b-col clas="" lg="5">

  							<div id="top_bar_right">
  								<font-awesome-icon :icon="['far', 'bell']" size="2x" />
  							</div>
  						</b-col>
  					</b-row> -->
            <font-awesome-icon class="icon" icon="bars" @click="main_nav_visibility= !main_nav_visibility" style="padding: 6px;display: block;flex-basis: 13%;align-self: center;height:100%;max-width:35px;}"/>

  					<b-navbar toggleable="md" style="flex-basis:100%;padding-left:0">
  						
              <b-navbar-nav class="">
							  
							  
							  
							  	<img src="/static/logo.png" style="width:80px;display:block" class="only-mobile"/>
							  
  						</b-navbar-nav>
  						<b-navbar-nav class="ml-auto">
  							<b-nav-item class="mobile-padding-10">
  								<b-link to="/dashboard">
  									<font-awesome-icon class="icon" icon="home"/>
  								</b-link>
  							</b-nav-item>

  							<b-nav-item class="mobile-padding-10">
	  							<b-dropdown variant="link" right class="top_bar_button" size="lg" no-caret>
	  								
	  									<template slot="button-content">
	  										<div class="icon-dropdown">
	  											<font-awesome-icon :icon="['far', 'bell']" />
	  										</div>
	  									</template>
	  									<b-dropdown-item href="#" disabled>You have no notifications!</b-dropdown-item>
	  								
	  							</b-dropdown>
  							</b-nav-item>

  							<b-nav-item class="only-desktop">
	  							<b-dropdown class="" variant="link" size="lg" no-caret>
	  								
	  									<template slot="button-content" class="top_bar_button">
	  										<div class="user_pic">
	  											<img class="scale" src="/static/re.png" />
	  										</div>
	  									</template>
	  									<b-dropdown-item href="#" class="color-green">Your Account</b-dropdown-item>
	  									<b-link @click="logout">Logout</b-link>

	  								
	  							</b-dropdown>
  							</b-nav-item>

  						</b-navbar-nav>
  					</b-navbar>
  				</div>
  				<div id="main_content">
  					<router-view></router-view>
					<!-- <a href="data:text/plain;base64,SGVsbG8sIFdvcmxkIQ%3D%3D">A</a> -->
  				</div>
  			</b-col>
  		</b-row>
  	</b-container>
  	
  </div>
</template>

<script>
import dropdown from 'vue-my-dropdown';
import loader from '../Loader.vue';

export default {
  name: 'Dashboard',
  data () {
    return {
      msg: 'Welcome to QdsPro',
	  visible:false,
	  slide_open:false,
	  main_nav_visibility:false
    }
  },
  computed: {
	  user_info: function() {
		  return this.$store.getters.user;
	  }
  },
  components: {
  	dropdown,
    loader
  },
  created: async function() {

    
  },
  mounted: async function() {

    // keep main_nav open on desktop
    if(window.innerWidth > 1280) {
      this.main_nav_visibility = true;
    }

    var user = this.$store.getters.user;

    if(!user.is_logged_in) {
      this.$router.replace('/login');
     } else {
      var action = await this.$store.dispatch('fetch_me');
      var action2 = this.$store.dispatch('fetch_doubts');
      this.$router.replace('/dashboard/assigned');
    }
  },
  methods: {
    async logout() {
      console.log('logging out');
      await this.$store.dispatch('logout');
      this.$toasted.show('Logged out successfully!',{type:'success'});
      this.$router.push('/login');
	},
	open() {
		this.slide_open = true;
	},
	close_main_nav() {
		this.main_nav_visibility = false;
	},
	goto(link) {
    if(window.innerWidth < 1280)
		this.main_nav_visibility=false;
		this.$router.push(link);
	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#mobile_user_info {
	padding: 20px;
	text-align:center;
}
#mobile_user_info .close{
	position:absolute;
	top:10px;
	right:10px;
	
}
.only-desktop {
	display: none;
}
.mobile-padding-10 {
	padding: 0 3px;
}
#top_bar {
	/*padding: 10px;*/
	top:0px;
	position: sticky;
	background-color: #262f3c;
	box-shadow: 0px 1px 15px 1px rgba(69,65,78,0.25);
	z-index: 999;
}

#top_bar .icon {
	color:white;
	font-size:1.3rem;
	cursor: pointer;
}

#top_bar .icon-dropdown {
	font-size:1.3rem;
	color: white;
	cursor: pointer;
}

#main_nav {
	height: 100vh;
	overflow: auto;
	padding-left: 10px;
	padding-right: 10px;

}

.nav-main-link .row .col-lg-8 {
	padding-left: 10px;
	padding-right: 10px;
}
.nav-icon {
	padding-left: 7px;
}
.navbar-nav {
	flex-direction: row;
	align-items: center;
}
.user_name {
	text-align: left;
	color:black;
	margin-bottom:0;
}
.user_info * {
	text-align: left;
	display: block;
}
#main_content {
	/*height: 100vh;*/
	overflow: auto;
  overflow-x: hidden;
}
#the_user_info {
	background-color: whitesmoke;
	/*padding: 5px 0;*/
}

.user_pic img {
	width: 50px;
	border-radius: 50px;
}

.action {
	text-align:right;
	margin-right: 15px;
}

.action > svg {
	margin: 0 17px;
}

#queries {
	padding: 5px 0;
	margin: 5px 0;
}

.nav-main-link {
	padding: 5px 0;
	margin: 2px 0;	
}
ul {
	list-style-type:none;
	margin-bottom: 0;
}
li a, li {
	color:white;
	display:block;
	outline: 0;
}

li a.active {
	color: #77bf43;
}

.collapsible {
	cursor: pointer;
}
.collapsible-ul {
	padding-left: 20px;
}
.collapsible-ul li a {
	padding:4px 14px;
	transition: ease background-color 0.4s;
  padding-left: 30px;
}
.collapsible-ul li a:hover {
	background-color: #434a53;
}
.collapsible-ul li a.active {
	background-color: #434a53;
	color:white;
	background:url(../../../static/tab-click.png);
  	background-size:cover;
}
.collapsible-heading {
	color:white;
	margin-bottom:0;
}
.nav-main-link a {
  padding: 10px 0;
}
.nav-main-link .row:focus {
  /*background:url(../../../static/tab-click.png);*/
  /*background-size:cover;*/
  color:white !important;
}
.collapsed .toggler {
	transform: rotate(180deg);
	
}

.toggler {
	transition: ease-in-out transform 0.4s;
	padding:0;
	text-align: center;
}

@media screen and (min-width: 768px) {
	#top_bar .navbar-expand-md .navbar-nav {
		align-items: center;
	}
}

@media screen and (min-width: 1280px) {
	.only-mobile {
		display:none !important;
	}
	.only-desktop {
		display: block;
	}
	.hide-on-desktop {
		display: none;
	}
	#main_wrapper {
		height: 100vh;
		overflow: auto;
	}
	#main_nav {
		flex-basis: 22%;
	}
}

@media screen and (max-width: 720px) {
	#main_nav {
		display: block;
		position: fixed;
		top:0;
		width:100%;
		left:0;
		overflow:auto;
		z-index: 99999;
	}

  #main_wrapper {

    background-color: #efefef;
    min-height: 100vh;
    display: flex;
    flex-direction: column;

  }
	

}

.normal-link {
  color:white;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue